import axios from "axios";

export default {
  namespaced: true,
  state: {
    readonly: false,
    generalData: {
      title: "",
      description: "",
      studyDisciplineId: null,
      studyTopicId: null,
      passTypeId: null,
      minutes: 0,
    },
    virtualPatient: {
      diaTestId: null,
      patientId: null,
      episodeId: null,
      isLabTakeOrder: false,
      isInstrumentalTakeOrder: false,
    },
    indicators: {
      info: {
        fio: "",
        logoUrl: "",
        birthday: "",
        gender: null,
        episodeAge: "",
      },
      anthropometricIndicators: [],
      vitalIndicators: [],
    },
    diagnostic: {
      filterMedia: {
        author: "",
        fileType: "",
        disabled: false,
      },
      dialog: false,
      dialogMedia: false,
      dialogAddMedia: false,
      flagInstrumental: false,
      selectedInstrumentalFile: [],
      selectPropertyInstrumental: null,
      selectedIndex: null,
      currentStep: null,
      methods: "skip",
      type: "down",
      levels: [
        {
          sectionId: "00000000-0000-0000-0000-000000000001",
          sectionName: "Сбор жалоб",
          visibleType: 1,
          sectionOrd: 1,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000002",
          sectionName: "Сбор анамнеза",
          visibleType: 1,
          sectionOrd: 2,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000003",
          sectionName: "Осмотр",
          visibleType: 1,
          sectionOrd: 3,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000004",
          sectionName: "Пальпация",
          visibleType: 1,
          sectionOrd: 4,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000005",
          sectionName: "Перкуссия",
          visibleType: 1,
          sectionOrd: 5,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000006",
          sectionName: "Аускультация",
          visibleType: 1,
          sectionOrd: 6,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000007",
          sectionName: "Постановка синдромального диагноза",
          visibleType: 1,
          sectionOrd: 7,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000008",
          sectionName: "Постановка предварительного диагноза",
          visibleType: 1,
          sectionOrd: 8,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000009",
          sectionName: "Назначение лабораторных исследований",
          visibleType: 1,
          sectionOrd: 9,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000010",
          sectionName: "Назначение инструментальных исследований",
          visibleType: 1,
          sectionOrd: 10,
          loading: true,
        },
        {
          sectionId: "00000000-0000-0000-0000-000000000011",
          sectionName: "Постановка окончательного диагноза",
          visibleType: 1,
          sectionOrd: 11,
          loading: true,
        },
      ],
      complaints: [],
      anamnesis: {
        life: [],
        diseases: [],
      },
      currentObjSprPhysResearch: null,
      dataSomaticStatusBodySystems: [],
      dataSomaticStatuses: [],
      syndromic: [],
      preliminary: [],
      finaly: [],
      mkbList: [],
      labaratory: [],
      instrumental: [],
      sortList: [],
      iconsList: [
        {
          icon: "ds.svg",
          localStatus: "",
          name: "ДС",
          nameLong: "Дыхательная система",
          id: "f99c9578-50ac-48b5-b94d-037cd8520304",
          loading: false,
        },
        {
          icon: "ls.svg",
          localStatus: "",
          name: "ЛС",
          nameLong: "Лимфатическая система",
          id: "c92c1881-5140-4cfc-9f55-a0c5f2cdc24d",
          loading: false,
        },
        {
          icon: "ms.svg",
          localStatus: "",
          name: "МС",
          nameLong: "Мочевая система",
          id: "ccca1011-8716-428a-95d5-3c7fca0d1b32",
          loading: false,
        },
        {
          icon: "ns.svg",
          localStatus: "",
          name: "НС",
          nameLong: "Нервная система",
          id: "8bbe6ce8-7234-428b-9350-b871e63bc378",
          loading: false,
        },
        {
          icon: "oda.svg",
          localStatus: "",
          name: "КМС",
          nameLong: "Костно-мышечная система",
          id: "c4f8d32b-8cfe-44da-9228-4938291693e5",
          loading: false,
        },
        {
          icon: "ps.svg",
          localStatus: "",
          name: "ПищС",
          nameLong: "Пищеварительная система",
          id: "b9003edc-c4ce-4d3b-afce-7db04f9c9fec",
          loading: false,
        },
        {
          icon: "poks.svg",
          localStatus: "",
          name: "ПС",
          nameLong: "Покровная система",
          id: "c7ab1583-f64e-4d1b-adc8-737178a04f15",
          loading: false,
        },
        {
          icon: "rs.svg",
          localStatus: "",
          name: "РС",
          nameLong: "Репродуктивная система",
          id: "9471c8ad-5c1f-4c0b-ae5a-3fdd9cd5e08e",
          loading: false,
        },
        {
          icon: "ss.svg",
          localStatus: "",
          name: "СС",
          nameLong: "Сенсорная система",
          id: "5b0dd881-6ede-4d62-b349-ef81b57024c4",
          loading: false,
        },
        {
          icon: "sss.svg",
          localStatus: "",
          name: "ССС",
          nameLong: "Сердечно-сосудистая система",
          id: "033a35c0-2d7f-4039-a0e1-5685e5f57c72",
          loading: false,
        },
        {
          icon: "es.svg",
          localStatus: "",
          name: "ЭС",
          nameLong: "Эндокринная система",
          id: "bfc31163-9143-42e2-b527-0fb8fac3b9c6",
          loading: false,
        },
      ],
      selectedProperty: {},
      selectedCircle: {
        index: null,
        bodyPartId: null,
        files: [],
        name: "",
      },
      arrayCircles: [
        {
          name: "Голова",
          bodyPartId: "59c86ea0-8c2e-40d6-878c-a8f96e2bfa7f",
          hover: false,
          array: [
            { cx: 163, cy: 18, r: 8, fill: "#33A56E" },
            { cx: 163, cy: 18, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Ухо правое",
          bodyPartId: "555B3272-3535-4928-9D9F-C016FEF6DE9B",
          hover: false,
          array: [
            { cx: 127, cy: 48, r: 8, fill: "#33A56E" },
            { cx: 127, cy: 48, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Ухо левое",
          bodyPartId: "F4E6024F-F131-45C1-B684-42C4342CCB1B",
          hover: false,
          array: [
            { cx: 200, cy: 48, r: 8, fill: "#33A56E" },
            { cx: 200, cy: 48, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Шея",
          bodyPartId: "2feed71b-48c5-478e-81d8-baff20e7c7a1",
          hover: false,
          array: [
            { cx: 163, cy: 102, r: 8, fill: "#33A56E" },
            { cx: 163, cy: 102, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Плечо правое",
          bodyPartId: "954ec204-c4ba-4ca0-80a8-943f83cc2849",
          hover: false,
          array: [
            { cx: 117, cy: 127, r: 8, fill: "#33A56E" },
            { cx: 117, cy: 127, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Предплечье правое",
          bodyPartId: "2a12eb2b-1739-4090-bc49-7aa981ae99c2",
          hover: false,
          array: [
            { cx: 101, cy: 205, r: 8, fill: "#33A56E" },
            { cx: 101, cy: 205, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Кисть правая",
          bodyPartId: "2805551f-766c-4e77-af34-d18583d875d3",
          hover: false,
          array: [
            { cx: 90, cy: 280, r: 8, fill: "#33A56E" },
            { cx: 90, cy: 280, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Кисть левая",
          bodyPartId: "d6f786a0-b617-4cd9-a3c8-0168616c7772",
          hover: false,
          array: [
            { cx: 237, cy: 280, r: 8, fill: "#33A56E" },
            { cx: 237, cy: 280, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Предплечье левое",
          bodyPartId: "90188616-c5e4-4b08-bfaf-baafe1afc2a6",
          hover: false,
          array: [
            { cx: 227, cy: 205, r: 8, fill: "#33A56E" },
            { cx: 227, cy: 205, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Грудная клетка",
          bodyPartId: "0dc3a76a-e655-4909-bc44-9e7c37859b4f",
          hover: false,
          array: [
            { cx: 163, cy: 155, r: 8, fill: "#33A56E" },
            { cx: 163, cy: 155, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Живот",
          bodyPartId: "01276954-9837-41a7-955f-78804a191e88",
          hover: false,
          array: [
            { cx: 163, cy: 225, r: 8, fill: "#33A56E" },
            { cx: 163, cy: 225, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Бедро правое",
          bodyPartId: "465f02ae-eb8b-4755-8ade-cbfa1321bef8",
          hover: false,
          array: [
            { cx: 123, cy: 292, r: 8, fill: "#33A56E" },
            { cx: 123, cy: 292, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Паховая область",
          bodyPartId: "5ca5f3cc-f234-4d79-94cd-96b868a95fd1",
          hover: false,
          array: [
            { cx: 163, cy: 310, r: 8, fill: "#33A56E" },
            { cx: 163, cy: 310, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Бедро левое",
          bodyPartId: "cce88c6e-b990-4ea3-aae5-28880a847d13",
          hover: false,
          array: [
            { cx: 203, cy: 292, r: 8, fill: "#33A56E" },
            { cx: 203, cy: 292, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Голень левая",
          bodyPartId: "2f8c85ba-86c4-4c5a-bcb0-2a5a8c8b476e",
          hover: false,
          array: [
            { cx: 187, cy: 402, r: 8, fill: "#33A56E" },
            { cx: 187, cy: 402, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Левый голеностопный сустав",
          bodyPartId: "939c50fd-9c5b-407b-a960-9f441aadb14c",
          hover: false,
          array: [
            { cx: 180, cy: 490, r: 8, fill: "#33A56E" },
            { cx: 180, cy: 490, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Стопа левая",
          bodyPartId: "e96e52b9-5c81-4b74-975e-322f55ae963e",
          hover: false,
          array: [
            { cx: 182, cy: 514, r: 8, fill: "#33A56E" },
            { cx: 182, cy: 514, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Голень правая",
          bodyPartId: "ef372b9f-394e-4395-b829-321e695dc568",
          hover: false,
          array: [
            { cx: 140, cy: 402, r: 8, fill: "#33A56E" },
            { cx: 140, cy: 402, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Правый голеностопный сустав",
          bodyPartId: "3e1a6de5-225e-4d5a-ab8e-8056d93a0bf6",
          hover: false,
          array: [
            { cx: 148, cy: 490, r: 8, fill: "#33A56E" },
            { cx: 148, cy: 490, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Стопа правая",
          bodyPartId: "9cf9ac57-8e26-498d-a519-6f1293fb5153",
          hover: false,
          array: [
            { cx: 142, cy: 514, r: 8, fill: "#33A56E" },
            { cx: 142, cy: 514, r: 4, fill: "white" },
          ],
          files: [],
        },
        {
          name: "Плечо левое",
          bodyPartId: "e9688445-d97c-4f6a-b2b1-dd061e9df031",
          hover: false,
          array: [
            { cx: 207, cy: 127, r: 8, fill: "#33A56E" },
            { cx: 207, cy: 127, r: 4, fill: "white" },
          ],
          files: [],
        },
      ],
    },
    criteria: {
      data: [],
    },
  },
  getters: {
    getGeneralData: (state) => state.generalData,
    getVirtualPatient: (state) => state.virtualPatient,
    getIndicators: (state) => state.indicators,
    getDiagnostic: (state) => state.diagnostic,
    getSelectedIndex: (state) => state.diagnostic.selectedIndex,
    getCriteria: (state) => state.criteria,
    getFlagReadonly: (state) => state.readonly,
  },
  mutations: {
    addLocalStatusForIconList(state, obj) {
      for (let i = 0; i < state.diagnostic.iconsList.length; i++) {
        if (state.diagnostic.iconsList[i].id === obj.id) {
          state.diagnostic.iconsList[i].localStatus = obj.localStatus;
        }
      }
    },
    checkViewOrNo(state, flag) {
      state.readonly = flag;
    },
    changeFlagConstructor(state, obj) {
      state.diagnostic[obj.name] = obj.value;
    },
    changeFlagAddMedia(state, value) {
      state.diagnostic.dialogAddMedia = value;
    },
    changeFilterMedia(state, obj) {
      state.diagnostic.filterMedia = Object.assign({}, obj);
    },
    selectPropertyInstrumental(state, element) {
      state.diagnostic.selectPropertyInstrumental = Object.assign({}, element);
    },
    changeFlagMedia(state, value) {
      state.diagnostic.dialogMedia = value;
    },
    changeFlagMissingStep(state, value) {
      state.diagnostic.dialog = value.flag;
      state.diagnostic.selectedIndex = value.index;
    },
    changeSelectedIndex(state, index) {
      state.diagnostic.selectedIndex = index;
    },
    saveConstructor(state, payload) {
      state[payload.name] = Object.assign({}, payload.data);
    },
    addDiaTestIdForVP(state, diaTestId) {
      state.virtualPatient.diaTestId = diaTestId;
    },
    resetGeneralData(state) {
      state.generalData = {
        title: "",
        description: "",
        studyDisciplineId: null,
        studyTopicId: null,
        passTypeId: null,
        minutes: 0,
      };
    },
    saveInfoPatientForIndicators(state, payload) {
      state.indicators.info = payload;
    },
    saveIndicatorsArray(state, payload) {
      for (let i = 0; i < payload.data.length; i++) {
        // if(payload.name === 'anthropometricIndicators') {
        //     if(payload.data[i].propertyName === 'ИМТ' || payload.data[i].propertyName === 'ИМТ (М)') {
        //         payload.data[i].isPathology = false;
        //     }
        // }

        payload.data[i].edite = false;
        payload.data[i].loadSpr = false;
        payload.data[i].loadVisible = false;
        payload.data[i].loadPatalogy = false;
        payload.data[i].listValues = [];
      }
      state.indicators[payload.name] = payload.data;
    },
    nextSection(state, index) {
      state.diagnostic.currentStep = index;
    },
    checkNextStep(state, obj) {
      let levels = state.diagnostic.levels;

      // Если добавил
      if (obj.methods === "add") {
        levels[obj.nextIndex].visibleType = 2;
        state.diagnostic.currentStep = obj.nextIndex;
      }

      // Если пропустил
      if (obj.methods === "skip") {
        levels[obj.nextIndex].visibleType = 3;
      }

      state.diagnostic.dialog = false;
    },
    replacementData(state, obj) {
      if (obj.nameGroup === "criteria" && obj.nameProperty === "data") {
        obj.serverData.list = state.criteria.listAll;
      }

      if (obj.nameProperty2)
        Object.assign(
          state[obj.nameGroup][obj.nameProperty][obj.nameProperty2][obj.index],
          obj.serverData
        );
      else
        Object.assign(
          state[obj.nameGroup][obj.nameProperty][obj.index],
          obj.serverData
        );
    },
    saveComplaints(state, payload) {
      for (let i = 0; i < payload.length; i++) {
        payload[i].inputText = false;
        payload[i].loadReturn = false;
        payload[i].loadViewOrNot = false;
      }
      state.diagnostic.complaints = payload;
    },
    saveAnamnesis(state, payload) {
      for (let i = 0; i < payload.data.length; i++) {
        payload.data[i].loadReturn = false;
        payload.data[i].loadViewOrNot = false;
        payload.data[i].inputText = false;
        payload.data[i].loadingSortOrderUp = false;
        payload.data[i].loadingSortOrderDown = false;

        // проставление ордеров если они пришли null
        if (!payload.data[i].sortOrder) payload.data[i].sortOrder = i;
      }

      if (payload.anamnesType === 1)
        state.diagnostic.anamnesis.life = payload.data;
      if (payload.anamnesType === 2)
        state.diagnostic.anamnesis.diseases = payload.data;
    },
    addComplaints(state) {
      state.diagnostic.complaints.push({
        episodeId: state.virtualPatient.episodeId,
        diaTestId: state.generalData.id,
        complaintText: "",
        isVisible: true,
        testDataType: 3,
      });
    },
    addAnamnesis(state, type) {
      let array = state.diagnostic.anamnesis,
        typeItem = type === 1 ? "life" : "diseases",
        orderPrev = 0;

      if (array[typeItem].length > 0)
        orderPrev = array[typeItem][array[typeItem].length - 1].sortOrder + 1;

      state.diagnostic.anamnesis[typeItem].push({
        episodeId: state.virtualPatient.episodeId,
        diaTestId: state.generalData.id,
        anamnesType: type,
        anamnesText: "",
        isVisible: true,
        testDataType: 3,
        sortOrder: orderPrev,
      });
    },
    saveVisibleBlockInDiagnostic(state, payload) {
      for (let i = 0; i < payload.length; i++) {
        for (let j = 0; j < state.diagnostic.levels.length; j++) {
          if (payload[i].sectionId === state.diagnostic.levels[j].sectionId) {
            state.diagnostic.levels[j].diaTestId = payload[i].diaTestId;
            state.diagnostic.levels[j].id = payload[i].id;
            state.diagnostic.levels[j].visibleType = payload[i].visibleType;
            state.diagnostic.levels[j].loading = false;
            break;
          }
        }
      }
    },
    saveSprPhysResearch(state, obj) {
      if (!obj) return;
      state.diagnostic.currentObjSprPhysResearch = obj;
    },
    saveSprBodySystem(state, array) {
      for (let i = 0; i < state.diagnostic.iconsList.length; i++) {
        for (let j = 0; j < array.length; j++) {
          if (state.diagnostic.iconsList[i].nameLong === array[j].name) {
            state.diagnostic.iconsList[i].id = array[j].id;
            state.diagnostic.iconsList[i].name = array[j].shortName;
          }
        }
      }
    },
    saveDataSomaticStatusBodySystems(state, array) {
      // Добавляем группы с показателями в список отрисовки частей тела
      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < state.diagnostic.iconsList.length; j++) {
          if (array[i].bodySystemId === state.diagnostic.iconsList[j].id) {
            state.diagnostic.iconsList[j].groups = array[i].groups;
            state.diagnostic.iconsList[j].localStatus = array[i].localStatus;
          }
        }
      }

      state.diagnostic.dataSomaticStatusBodySystems = array;
    },
    saveDataSomaticStatuses(state, obj) {
      if (obj.data && obj.data.length > 0) {
        for (let i = 0; i < obj.data.length; i++) {
          obj.data[i].listValues = [];
          obj.data[i].edite = false;
          obj.data[i].viewImage = false;
          obj.data[i].loadingImage = false;
          obj.data[i].loadSpr = false;
          obj.data[i].loadVisible = false;
          obj.data[i].loadPatalogy = false;
        }
      }

      if (obj.showMore) {
        state.diagnostic.dataSomaticStatuses.push(...obj.data);

        return;
      }

      state.diagnostic.dataSomaticStatuses = obj.data;
    },
    saveMkbList(state, payload) {
      for (let i = 0; i < payload.length; i++) {
        payload[i].nameCode = `${payload[i].code} - ${payload[i].name}`;
      }
      payload.sort((a, b) => (a.code > b.code ? 1 : b.code > a.code ? -1 : 0));
      state.diagnostic.mkbList = payload;
    },
    saveSyndromDiagnoses(state, payload) {
      state.diagnostic.mkbList = payload;
    },
    saveDiagnosis(state, obj) {
      for (let i = 0; i < obj.data.length; i++) {
        obj.data[i].loadReturn = false;
        obj.data[i].loadViewOrNot = false;
      }
      if (obj.diagnoseType === 1) state.diagnostic.syndromic = obj.data;
      if (obj.diagnoseType === 2) state.diagnostic.preliminary = obj.data;
      if (obj.diagnoseType === 3) state.diagnostic.finaly = obj.data;
    },
    addDiagnose(state, obj) {
      state.diagnostic[obj.name].push({
        episodeId: state.virtualPatient.episodeId,
        diagnoseId: null,
        diagnoseType: obj.type,
        diagnoseName: null,
        diaTestId: state.generalData.id,
        isVisible: true,
        testDataType: 3,
      });
    },
    saveResearches(state, payload) {
      console.log(payload);

      for (let i = 0; i < payload.data.length; i++) {
        payload.data[i].edite = false;
        payload.data[i].loadSpr = false;
        payload.data[i].loadVisible = false;
        payload.data[i].loadPatalogy = false;
        payload.data[i].loadMedia = false;
        payload.data[i].listValues = [];
      }

      if (!payload.showMore) {
        state.diagnostic[payload.name] = payload.data;
        state.diagnostic.sortList = [];
      } else {
        state.diagnostic[payload.name].push(...payload.data);
      }

      let orderList = payload.data.map((x) => x.ord);

      for (let i = 0; i < orderList.length; i++) {
        state.diagnostic.sortList.push(orderList[i]);
      }
    },
    saveCriteria(state, payload) {
      for (let i = 0; i < payload.length; i++) {
        payload[i].list = [];
        payload[i].inputText = "";
      }
      state.criteria.data = payload;
    },
    addCriteria(state) {
      state.criteria.data.push({
        diaTestId: state.generalData.id,
        criteriaId: null,
        criteriaMinValue: 0,
        criteriaMaxValue: 0,
        list: [],
        url: "",
      });
    },
    saveListForCriteria(state, array) {
      state.criteria.listAll = array;

      if (state.criteria.data.length > 0) {
        for (let i = 0; i < state.criteria.data.length; i++) {
          state.criteria.data[i].list = array;
        }
      }
    },
    changeSelectedCircle(state, obj) {
      state.diagnostic.selectedCircle = {
        index: obj.index,
        bodyPartId: obj.element.bodyPartId,
        files: obj.element.files,
        name: obj.element.name,
      };
    },
    saveSelectedProperty(state, obj) {
      state.diagnostic.selectedProperty = obj;
      state.diagnostic.selectedCircle = {
        index: null,
        bodyPartId: null,
        files: [],
        name: "",
      };
    },
    saveFile(state, obj) {
      if (obj.data.length === 0) {
        if (obj.nameProperty2)
          state.diagnostic[obj.nameProperty][obj.nameProperty2] = [];
        else state.diagnostic[obj.nameProperty] = [];

        return;
      }

      if (obj.nameProperty2) {
        // console.log('if', obj.data);

        if (Array.isArray(obj.data))
          state.diagnostic[obj.nameProperty][obj.nameProperty2] = obj.data;
        else
          state.diagnostic[obj.nameProperty][obj.nameProperty2].push(obj.data);

        return;
      }

      if (Array.isArray(obj.data))
        state.diagnostic[obj.nameProperty] = obj.data;
      else state.diagnostic[obj.nameProperty].push(obj.data);
    },
    resetFiles(state) {
      for (let i = 0; i < state.diagnostic.arrayCircles.length; i++) {
        state.diagnostic.arrayCircles[i].files = [];
      }
    },
    saveFiles(state, array) {
      // очищаем для начала все файлы
      for (let i = 0; i < state.diagnostic.arrayCircles.length; i++) {
        state.diagnostic.arrayCircles[i].files = [];
      }

      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < state.diagnostic.arrayCircles.length; j++) {
          if (
            array[i].bodyPartId === state.diagnostic.arrayCircles[j].bodyPartId
          ) {
            state.diagnostic.arrayCircles[j].files.push(array[i]);
          }
        }
      }
    },
    deleteFile(state, id) {
      let index = state.diagnostic.selectedCircle.files.findIndex(
        (f) => f.id === id
      );
      state.diagnostic.selectedCircle.files.splice(index, 1);
    },
    deleteDiagnos(state, obj) {
      let nameState = "",
        index = null;

      if (obj.diagnoseType === 1) nameState = "syndromic";
      if (obj.diagnoseType === 2) nameState = "preliminary";
      if (obj.diagnoseType === 3) nameState = "finaly";

      index = state.diagnostic[nameState].findIndex(
        (f) => f.id === obj.item.id
      );

      // console.log(nameState, index);

      if (index >= 0) {
        state.diagnostic[nameState].splice(index, 1);
      }
    },
    deleteAnamnesObj(state, obj) {
      let index = state.diagnostic.anamnesis[obj.nameState].findIndex(
        (f) => f.id === obj.item.id
      );
      if (index >= 0)
        state.diagnostic.anamnesis[obj.nameState].splice(index, 1);
    },
    deleteComplaintObj(state, obj) {
      let index = state.diagnostic.complaints.findIndex(
        (f) => f.id === obj.item.id
      );
      if (index >= 0) state.diagnostic.complaints.splice(index, 1);
    },
    deleteCriteriaObj(state, obj) {
      let index = state.criteria.data.findIndex((f) => f.id === obj.id);
      if (index >= 0) state.criteria.data.splice(index, 1);
    },
    returnValueAsItWas(state, obj) {
      // console.log('returnValueAsItWas', obj);

      if (obj.oldValue.levelDeep > 1) {
        Object.assign(
          state[obj.oldValue.nameGroup][obj.oldValue.nameProperty][
            obj.oldValue.nameProperty2
          ][obj.oldValue.index],
          obj.newValue
        );
        return;
      }

      Object.assign(
        state[obj.oldValue.nameGroup][obj.oldValue.nameProperty][
          obj.oldValue.index
        ],
        obj.newValue
      );
    },
    mutationVisible(state, obj) {
      for (let i = 0; i < state.indicators[obj.nameState].length; i++) {
        state.indicators[obj.nameState][i].isVisible = obj.visible;
      }
    },
  },
  actions: {
    saveGeneralInformation({ commit, rootState }, object) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/AddOrUpdateTest`, object)
          .then((res) => {
            commit("saveConstructor", { name: "generalData", data: res.data });
            commit("addDiaTestIdForVP", res.data.id);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getGeneralInformation({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}DiaTest/Get?id=${id}`)
          .then((res) => {
            commit("saveConstructor", { name: "generalData", data: res.data });
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addVirtualInformation({ commit, rootState }, object) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/AddPropertyForNewTest`, object)
          .then((res) => {
            commit("saveConstructor", {
              name: "virtualPatient",
              data: res.data,
            });
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveVirtualInformation({ commit, rootState }, object) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/AddOrUpdateTestProperty`, object)
          .then((res) => {
            commit("saveConstructor", {
              name: "virtualPatient",
              data: res.data,
            });
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getVirtualInformation({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}DiaTest/GetTestPropertyByTestId?id=${id}`)
          .then((res) => {
            if (res.status === 200) {
              commit("saveConstructor", {
                name: "virtualPatient",
                data: res.data,
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAnthropometricIndicators({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/GetAnthropometricIndicators`, {
            testId: obj.testId,
            propertyIds: obj.propertyIds,
            pageSize: obj.pageSize,
            currentPage: obj.currentPage,
          })
          .then((res) => {
            if (res.status === 200) {
              commit("saveIndicatorsArray", {
                name: "anthropometricIndicators",
                data: res.data.data,
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getVitalIndicators({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/GetVitalIndicators`, {
            testId: obj.testId,
            propertyIds: obj.propertyIds,
            pageSize: obj.pageSize,
            currentPage: obj.currentPage,
          })
          .then((res) => {
            if (res.status === 200) {
              commit("saveIndicatorsArray", {
                name: "vitalIndicators",
                data: res.data.data,
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveInline({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}${obj.url}`, obj.obj)
          .then((res) => {
            if (res.status === 200) {
              if (obj.index || obj.index === 0) {
                commit("replacementData", {
                  nameGroup: obj.nameGroup,
                  nameProperty: obj.nameProperty,
                  nameProperty2: obj.nameProperty2
                    ? obj.nameProperty2
                    : undefined,
                  index: obj.index,
                  serverData: res.data,
                });
              }
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getVisibleBlockInDiagnostic({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetDiaTestSectionVisiblesByTestId?id=${id}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveVisibleBlockInDiagnostic", res.data);
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveFlagsForDiagnostic({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/AddOrUpdateDiaTestSectionVisible`, obj)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveSort({ rootState }, object) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTest/ChangeAnamnesOrder?testId=${object.testId}`,
            object.array
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getComplaints({ commit, rootState }, testId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}DiaTest/GetComplaintsByTestId?testId=${testId}`)
          .then((res) => {
            if (res.status === 200) {
              commit("saveComplaints", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAnamnesis({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetAnamnesesByTestId?testId=${obj.testId}&anamnesType=${obj.anamnesType}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveAnamnesis", {
                data: res.data,
                anamnesType: obj.anamnesType,
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSomaticStatusBodySystems({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetSomaticStatusBodySystems?testId=${obj.testId}&physResearchId=${obj.physResearchId}&isVisible=${obj.isVisible}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveDataSomaticStatusBodySystems", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSomaticStatusesByTestId({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/GetSomaticStatuses`, {
            testId: obj.testId,
            bodySystemId: obj.bodySystemId,
            physResearchId: obj.physResearchId,
            ...obj.params,
          })
          .then((res) => {
            if (res.status === 200) {
              commit("saveDataSomaticStatuses", {
                data: res.data.data,
                showMore: obj.showMore,
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSprPhysResearch({ commit, rootState }, query) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.apiGuide}api/SprPhysResearch/GetAll?query=${query}`)
          .then((res) => {
            if (res.status === 200) {
              commit(
                "saveSprPhysResearch",
                res.data.length > 0 ? res.data[0] : null
              );
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAllSprBodySystem({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.apiGuide}api/SprBodySystem/GetAll`)
          .then((res) => {
            if (res.status === 200) {
              commit("saveSprBodySystem", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMkb({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.apiGuide}api/SprMkb10/GetAll`)
          .then((res) => {
            if (res.status === 200) {
              commit("saveMkbList", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSyndromDiagnoses({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.apiGuide}api/SprSyndromicDiagnose/GetAll`)
          .then((res) => {
            if (res.status === 200) {
              commit("saveSyndromDiagnoses", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDataDiagnoses({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetDiagnosesByTestId?testId=${obj.testId}&diagnoseType=${obj.diagnoseType}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveDiagnosis", {
                data: res.data,
                diagnoseType: obj.diagnoseType,
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getResearchesByTestId({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}${obj.url}`, {
            testId: obj.testId,
            ...obj.params,
          })
          .then((res) => {
            if (res.status === 200) {
              commit("saveResearches", {
                data: res.data.data,
                name: obj.name,
                showMore: obj.showMore,
                totalRecords: res.data.totalRecords,
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getCriteriaByTestId({ commit, rootState }, testId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}DiaTest/GetCriteriaByTestId?testId=${testId}`)
          .then((res) => {
            if (res.status === 200) {
              commit("saveCriteria", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMediaForInstrumental({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetMediaFilesByPropertyId?testId=${obj.testId}&propertyId=${obj.propertyId}&sectionId=${obj.sectionId}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveFile", {
                data: res.data,
                nameProperty: "selectedInstrumentalFile",
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMediaFilesByPropertyId({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetMediaFilesByPropertyId?testId=${obj.testId}&propertyId=${obj.propertyId}&type=${obj.type}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("saveFiles", res.data);
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    savingFile({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/AddOrUpdateMediaFile`, obj.params)
          .then((res) => {
            if (res.status === 200) {
              commit("saveFile", {
                data: res.data,
                nameProperty: obj.nameProperty,
                nameProperty2: obj.nameProperty2,
              });
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteFile({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `${rootState.api}DiaTest/DeleteMediaFile?fileId=${obj.item.id}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("deleteFile", obj.item.id);
              resolve(true);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteDiagnose({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `${rootState.api}DiaTest/DeleteDiagnose?id=${obj.item.id}&testId=${obj.item.diaTestId}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("deleteDiagnos", obj);
              resolve(true);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteAnamnes({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `${rootState.api}DiaTest/DeleteAnamnese?id=${obj.item.id}&testId=${obj.testId}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("deleteAnamnesObj", obj);
              resolve(true);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteComplaint({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `${rootState.api}DiaTest/DeleteComplaint?id=${obj.item.id}&testId=${obj.testId}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("deleteComplaintObj", obj);
              resolve(true);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteCriteria({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${rootState.api}DiaTest/DeleteCriteria?id=${obj.id}`)
          .then((res) => {
            if (res.status === 200) {
              commit("deleteCriteriaObj", obj);
              resolve(true);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    resetValue({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `${rootState.api}DiaTest/${obj.url}?id=${obj.item.id}&testId=${obj.testId}`
          )
          .then((res) => {
            if (res.status === 200) {
              commit("returnValueAsItWas", {
                oldValue: obj,
                newValue: res.data,
              });
              resolve(true);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSprAntrOrVital({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}${obj.url}`, { testId: obj.testId })
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSprLabResearch({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetLabResearchGroups?testId=${obj.testId}&isVisible=${obj.isVisible}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSprInstrumentalResearch({ rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}DiaTest/GetInstrumentalResearchGroups?testId=${obj.testId}&isVisible=${obj.isVisible}`
          )
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    UpdateIndicatorsVisible({ commit, rootState }, object) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTest/${object.url}?testId=${object.testId}&visible=${object.visible}`,
            {}
          )
          .then((res) => {
            commit("mutationVisible", {
              nameState: object.nameState,
              visible: object.visible,
            });
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    UpdateGroupVisible({ commit, rootState }, object) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTest/${object.url}?testId=${object.testId}&physResearchId=${object.physResearchId}&groupId=${object.groupId}&visible=${object.visible}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    refreshDiaTestProperties({ rootState }, diaTestId) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}DiaTest/RefreshDiaTestProperties?testId=${diaTestId}`,
            {}
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateVisibleForNewIndicators({ rootState }, object) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}DiaTest/UpdateVisibleForNewIndicators`, object)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
